import L from "leaflet"

export const selectedIcon = L.divIcon({
  className: "",
  html: `<div style="
    width:28px;height:28px;
    background:#10b981;
    border:3px solid #fff;
    border-radius:50% 50% 50% 0;
    transform:rotate(-45deg);
    box-shadow:0 2px 8px rgba(0,0,0,0.5);
  "></div>`,
  iconAnchor: [14, 28],
  popupAnchor: [0, -28],
})

export const pulsingIcon = L.divIcon({
  className: "",
  html: `
    <div style="position:relative;width:40px;height:40px;">
      <div style="
        position:absolute;inset:0;
        background:#10b981;border-radius:50%;
        opacity:0.25;animation:gps-pulse 1.5s ease-out infinite;
      "></div>
      <div style="
        position:absolute;top:50%;left:50%;
        transform:translate(-50%,-50%);
        width:16px;height:16px;
        background:#10b981;
        border:2.5px solid #fff;border-radius:50%;
        box-shadow:0 0 0 3px rgba(16,185,129,0.3);
      "></div>
    </div>
    <style>
      @keyframes gps-pulse {
        0%{transform:scale(0.5);opacity:0.4}
        100%{transform:scale(2.5);opacity:0}
      }
    </style>
  `,
  iconAnchor: [20, 20],
})